/**
 * authAxiosGuard.js
 * ==========================================================================
 * Installs GLOBAL axios response interceptor so ANY module that imports axios
 * directly (not just apiClient) will trigger session-expired flow when the
 * backend returns 401 Unauthorized.
 *
 * Dispatches 'auth:expired' window event → IdleTimeout listens & logs the user out.
 *
 * Only 1 install per page load (guarded by module-level flag).
 * 2026-07-15
 */
import axios from 'axios';

let installed = false;
let lastDispatchAt = 0;

export function installAuthAxiosGuard() {
  if (installed) return;
  installed = true;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      if (status === 401) {
        // Only for authenticated API paths (not for login endpoint itself)
        const url = (error?.config?.url || '').toString();
        // 2026-02 FIX: Also whitelist customer portal login endpoint to prevent
        // false-positive 'session expired' redirect when portal login returns 401
        const isLoginEndpoint = /\/api\/(v2\/)?auth\/(login|register|forgot|reset)/i.test(url)
          || /\/api\/(v2\/)?portal\/[^\/]+\/(login|register|forgot|reset|verify)/i.test(url);
        if (!isLoginEndpoint) {
          const now = Date.now();
          if (now - lastDispatchAt > 3000) {
            lastDispatchAt = now;
            try { window.dispatchEvent(new CustomEvent('auth:expired')); } catch (_) { /* noop */ }
          }
        }
      }
      return Promise.reject(error);
    }
  );
}
